import 'css-chunksrc/client/pages/zonePage/wbsPage/styles.scss';export default {
  "listsPage": "_listsPage_u636e_1",
  "header": "_header_u636e_8",
  "toolbar": "_toolbar_u636e_19",
  "heading": "_heading_u636e_36",
  "button": "_button_u636e_42",
  "main": "_main_u636e_67",
  "wbs": "_wbs_u636e_74",
  "statuses": "_statuses_u636e_78",
  "listsList": "_listsList_u636e_85",
  "creationMenu": "_creationMenu_u636e_89",
  "exportButton": "_exportButton_u636e_93"
};